import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { NzSafeAny } from 'ng-zorro-antd/core/types';

export const inListValidator =
  (list: NzSafeAny[]): ValidatorFn =>
  (ctl: AbstractControl): ValidationErrors | null =>
    list.includes(ctl.value) ? null : { notInList: true };
